// @ts-nocheck
import { Column } from 'react-table'
import { UserActionsCell } from './UserActionsCell'
import { UserCustomHeader } from './UserCustomHeader'
import { UserSelectionHeader } from './UserSelectionHeader'
import { UserSelectionCell } from './UserSelectionCell'
import { User } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='USER.TABLE.COLUMN.FIRSTNAME' defaultMessage='First Name' />}
        className='min-w-125px'
      />
    ),
    id: 'name',
    accessor: 'name',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='USER.TABLE.COLUMN.EMAIL' defaultMessage='Email' />}
        className='min-w-200px'
      />
    ),
    id: 'email',
    accessor: 'email',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='USER.TABLE.COLUMN.PHONENUMBER' defaultMessage='Phone Number' />}
        className='min-w-150px'
      />
    ),
    id: 'phone',
    accessor: 'phone',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='USER.TABLE.COLUMN.ROLE' defaultMessage='Role' />}
        className='min-w-150px'
      />
    ),
    id: 'role',
    accessor: (row) => row.roles?.[0]?.name || 'No Role',
    Cell: ({ value }) => <span className='text-primary'>{value}</span>,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='USER.TABLE.COLUMN.STATUS' defaultMessage='Status' />}
        className='min-w-100px'
      />
    ),
    id: 'status',
    accessor: 'status',
    Cell: ({ value }) => (
      <span className={`badge ${value ? 'badge-success' : 'badge-danger'}`}>
        {value ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Action' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <UserActionsCell id={props.data[props.row.index].id} />,
  },
]

export { usersColumns }
